import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Camera from "@material-ui/icons/Camera";
import Palette from "@material-ui/icons/Palette";
import Favorite from "@material-ui/icons/Favorite";
// React icons
import { FaTwitter, FaBalanceScaleRight, FaCouch, FaBrain } from 'react-icons/fa';
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from "components/CustomButtons/Button.jsx";
import { useAuthState } from 'react-firebase-hooks/auth';
import {isNewUser } from '../../services/firebase'


import IdModal from './IdModal'

import firebase from "gatsby-plugin-firebase"
import "firebase/auth";
import "firebase/database"
import "firebase/storage"

export default function NewMember(props) {
    const [user, setUser] = React.useState(props.fireUser);
    const [progress, setProgress] = React.useState(props);
    const [userData, setUserData] = React.useState(props.UD)
    const [idVar, setIDVariant] = React.useState(2)
    const [idFront, setIDFront] = React.useState(false);
    const [idBack, setIDback] = React.useState(false);
    const [idVerificationStage, setIDverificationStage] = React.useState({front: false, scan: false})


    const { classes, ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );

    const selectIDVariant = (event) => {
        setIDVariant(event.target.idVarChoice)
    }

    const [idChoice, setIdChoice] = React.useState({
        ID_Book: false,
        ID_Card: true,
        Drivers: false,
      });
    
      const handleChange = (event) => {
        setIdChoice({ ...idChoice, [event.target.name]: event.target.checked });
      };
    
      const { ID_Book, ID_Card, Drivers } = idChoice;
      const error = [ID_Book, ID_Card, Drivers].filter((v) => v).length !== 1;

    React.useEffect(() => {
        var newU = isNewUser();
        
    }, []);

    const verifyAge = (e) => {
        e.preventDefault();
        
        var id = ""
        var file = e.target.files[0];
        console.log(e.target)
        console.log(e.target.id)

        id = e.target.id
        var side = id.split("-")
        console.log(side[1])
        var db = firebase.database();

        var storageRef = firebase.storage().ref();

        var memberRef = storageRef.child("/MemberProfiles/" + user.uid + "/ID/");
        var imageRef = memberRef.child(file.name);
        var Member = db.ref('/Members/' + user.uid + "/ID/");

        if(side[1]=== "F"){
            console.log("front")
            
            imageRef.put(file).then((snapshot) => {
                setIDverificationStage({ ...idVerificationStage, front: true })
            snapshot.ref.getDownloadURL().then(url => { Member.update({ front: JSON.stringify(url) }) })
            console.log(`File ${file.name} uploaded!`)
            
        }).finally(() => {
            console.log(idVerificationStage)
        }).catch(err => {console.log(err)})
        }
        else
        {
            console.log("back")
            setIDverificationStage({ ...idVerificationStage, scan: true })
            imageRef.put(file).then((snapshot) => {
            
                snapshot.ref.getDownloadURL().then(url => { Member.update({ scan: JSON.stringify(url) }); })
                console.log(`File ${file.name} uploaded!`)
                
            }).finally(() => {
                console.log(idVerificationStage)
            }).catch(err => {console.log(err)})
        }
        
        // var db = firebase.database();

        // var storageRef = firebase.storage().ref();

        // var memberRef = storageRef.child("/MemberProfiles/" + user.uid + "/ID/");
        // var imageRef = memberRef.child(file.name)
        // var Member = db.ref('/Members/' + user.uid + "/ID/");
        // imageRef.put(file).then((snapshot) => {
            
        //     snapshot.ref.getDownloadURL().then(url => { Member.set({ doc: JSON.stringify(url) }) })
        //     console.log(`File ${file.name} uploaded!`)
            
        // }).finally(() => isNewUser());

        
        
        
    }

    const isVerified = () => {
        console.log(userData);
        console.log(user);
        if(userData.profileURL !== "" && userData.ID !== "" && user.emailVerified)
        {
            var db = firebase.database();
            var Member = db.ref('/Members/' + user.uid);
            Member.update({ New: false, Points: 100});
            return true
        }
        return false
    }

    const verifyProfilePic = (e) => {
        e.preventDefault();
       

        var file = e.target.files[0];

        var db = firebase.database();

        var storageRef = firebase.storage().ref();

        var memberRef = storageRef.child("/MemberProfiles/" + user.uid + "/ProfilePicture/");
        var imageRef = memberRef.child(file.name)
        var Member = db.ref('/Members/' + user.uid);
        imageRef.put(file).then((snapshot) => {
            
            snapshot.ref.getDownloadURL().then(url => { Member.update({profileURL: url}) })
            console.log(`File ${file.name} uploaded!`)
        }).finally(() => isNewUser());
        
    }


    const verifyEmail = (e) => {
        e.preventDefault();
        
        var user = firebase.auth().currentUser;

        user.sendEmailVerification().then(function () {
            console.log("Verification Email Sent")
        }).catch(function (error) {
            // An error happened.
        }).finally(() => isNewUser());
    }

    const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);

    return (
        <>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8} className={classes.navWrapper}>
                                    <GridContainer justify="center">
                                        <GridItem xs={12} sm={12} md={6}>
                                        {userData.ID.completed === true  ? "Proof of ID caputred. You will be notified once this has been completed." :
                                        <>
                                            <p>Unfortunately we do require all members to be over the age of 21.</p>
                                            <IdModal uid={user.uid}/>
                            </>}
                                        </GridItem>
                                        
                                    </GridContainer>
                               
                </GridItem>
            </GridContainer>
        </>
    );
}
